import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tracking } from 'src/app/models/server/tracking';
import { environment } from "src/environments/environment";


@Injectable({
	providedIn: 'root'
})
export class TrackingsService {

		/** URL pour le webService */
		public baseUrl;
		
	/**
	 * Constructeur
	 * */
	constructor(private http: HttpClient) {
		if (environment.production) {
			this.baseUrl = '';
		} else {
			this.baseUrl = environment.serverUrl;
		}
	}

	/**
	* Récupère les informations d'un dossier
	* @param trackingId: Id du dossier
	*/
	public get(trackingId: string): Observable<Tracking> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' })
		};

		return this.http.get<Tracking>(this.baseUrl + `/api/trackings/${trackingId}`, httpOptions);
	}
}